import React, { Component } from 'react';
import AvailableDriversMapView from './available-drivers-map-view';
import {connect} from 'react-redux';
import { getAvailableDrivers } from '../available-drivers/available-drivers-actions';
import { removeCurrentDriverCardOnMap, setCurrentDriverCardOnMap } from './available-drivers-map-actions';

class AvailableDriversMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      center: {lat: 51.509865, lng: -0.118092},
      zoom: 11,
      showHomeLocations: true
    }
  }

  toggleHomeLocations = () => this.setState({showHomeLocations: !this.state.showHomeLocations});

  componentDidMount() {
    this.props.getAvailableDrivers()
  }

  render() {
    return (
      <AvailableDriversMapView
        center={this.state.center}
        zoom={this.state.zoom}
        moveYasir={this.moveYasir}
        toggleHomeLocations={this.toggleHomeLocations}
        showHomeLocations={this.state.showHomeLocations}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  availableDrivers: state.availableDrivers,
  liveDriverLocations: state.availableDrivers.list.filter(driver => !!driver.lastLocation),
  driverHomeLocations: state.availableDrivers.list.filter(driver => !!driver.home),
  availableDriversMap: state.availableDriversMap
});

const mapDispatchToProps = {
  getAvailableDrivers: getAvailableDrivers,
  setCurrentDriverCardOnMap: setCurrentDriverCardOnMap,
  removeCurrentDriverCardOnMap: removeCurrentDriverCardOnMap
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailableDriversMap);



// WEBPACK FOOTER //
// ./src/components/available-drivers-map/available-drivers-map.js